"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$SQUARE_PARENTHESES_INLINE = exports.$CURLY_BRACKETS_INLINE = exports.$SQUARE_BRACKETS_INLINE = exports.$ROUND_PARENTHESES_INLINE = exports.makeParenthesesInline = exports.makeReParenthesesInlineTextChars = exports.ANY_PARENTHESES_INLINE = exports.$MISMATCH_END_PARENTHESIS = exports.$MISMATCH_START_PARENTHESIS = exports.$OUTSIDE_PARENTHESES_INLINE_EXCLUDE_TRAILING_SPACES = exports.makeReOutsideParenthesesTextChars = exports.$OUTSIDE_PARENTHESES_INLINE_EXCLUDE_TRAILING_SPACES_WITHOUT_TOPLEVEL_INLINE_TOKEN = exports.$PERIOD_SENTENCE_FRAGMENT = exports.makeRePeriodSentenceTextChars = exports.$charRef = exports.$sentenceChildrenWithoutToplevelInlineToken = exports.$sentenceChildren = exports.sentenceChildrenToString = void 0;
const std_1 = require("../../../law/std");
const controls_1 = require("../../../node/el/controls");
const el_1 = require("../../../node/el");
const util_1 = require("../../../util");
const factory_1 = require("../factory");
const lexical_1 = require("./lexical");
const std = __importStar(require("../../../law/std"));
const _xml_1 = __importDefault(require("./$xml"));
// import { pointerRangesCandidateChars, reSuppressPointerRanges } from "./$pointerRanges";
// import { ptnLawNumLike } from "../../../law/lawNum";
const error_1 = require("../error");
const generic_parser_1 = require("generic-parser");
const sentenceChildrenToString = (els) => {
    const runs = [];
    for (const el of els) {
        if (typeof el === "string") {
            runs.push(/* $$$$$$ */ el.replace(/\r|\n/g, "") /* $$$$$$ */);
        }
        else if (el.tag === "__CapturedXML" || el.tag === "__UnexpectedXML") {
            runs.push(/* $$$$$$ */ el.children.map(c => typeof c === "string" ? c : c.outerXML()).join("") /* $$$$$$ */);
        }
        else if (el instanceof controls_1.__Parentheses) {
            runs.push(/* $$$$$$ */ [el.start.text(), ...(0, exports.sentenceChildrenToString)(el.content.children), el.end.text()].join("") /* $$$$$$ */);
        }
        else if (el instanceof controls_1.____Declaration) {
            runs.push(/* $$$$$$ */ [...(0, exports.sentenceChildrenToString)(el.children)].join("") /* $$$$$$ */);
        }
        else if (el.isControl) {
            runs.push(/* $$$$$$ */ el.text().replace(/\r|\n/g, "") /* $$$$$$ */);
        }
        else if (el.tag === "Ruby" || el.tag === "Sub" || el.tag === "Sup" || el.tag === "QuoteStruct") {
            runs.push(/* $$$$$$ */ el.outerXML() /* $$$$$$ */);
        }
        else if (el.tag === "ArithFormula") {
            runs.push(/* $$$$$$ */ el.outerXML() /* $$$$$$ */);
        }
        else if (el.tag === "Line") {
            runs.push(/* $$$$$$ */ el.outerXML() /* $$$$$$ */);
        }
        else {
            throw (0, util_1.assertNever)(el);
        }
    }
    return /* $$$$$$ */ `${runs.join("")}` /* $$$$$$ */;
};
exports.sentenceChildrenToString = sentenceChildrenToString;
exports.$sentenceChildren = factory_1.factory
    .withName("sentenceChildren")
    .action(r => r
    .sequence(c => c
    .and(r => r
    .oneOrMore(r => r
    .choice(c => c
    .or(() => exports.$OUTSIDE_PARENTHESES_INLINE_EXCLUDE_TRAILING_SPACES)
    .or(() => exports.ANY_PARENTHESES_INLINE)
    .or(() => exports.$MISMATCH_END_PARENTHESIS))), "texts")), (({ texts }) => {
    return {
        value: texts.map(t => t.value).flat(),
        errors: texts.map(t => t.errors).flat(),
    };
}));
exports.$sentenceChildrenWithoutToplevelInlineToken = factory_1.factory
    .withName("sentenceChildrenWithoutToplevelInlineToken")
    .action(r => r
    .sequence(c => c
    .and(r => r
    .oneOrMore(r => r
    .choice(c => c
    .or(() => exports.$OUTSIDE_PARENTHESES_INLINE_EXCLUDE_TRAILING_SPACES_WITHOUT_TOPLEVEL_INLINE_TOKEN)
    .or(() => exports.ANY_PARENTHESES_INLINE)
    .or(() => exports.$MISMATCH_END_PARENTHESIS))), "texts")), (({ texts }) => {
    return {
        value: texts.map(t => t.value).flat(),
        errors: texts.map(t => t.errors).flat(),
    };
}));
exports.default = exports.$sentenceChildren;
const reCharRef = /^&#(\d+|x[\da-fA-F]+);/;
exports.$charRef = factory_1.factory
    .withName("inlineToken")
    .sequence(s => s
    .and(r => r.regExpObj(reCharRef), "charRef")
    .action(({ charRef, range }) => {
    const intStr = charRef[1].toLowerCase();
    const isHex = intStr.startsWith("x");
    const int = parseInt(intStr.slice(isHex ? 1 : 0), isHex ? 16 : 10);
    return {
        value: new controls_1.__Text(String.fromCharCode(int), range()),
        errors: [],
    };
}));
const makeRePeriodSentenceTextChars = (stopChars) => new RegExp(`^(?:(?![ァ-ヿ${stopChars}])[^\r\n&<>()（）[\\]［］{}｛｝「」 　\t。])+`);
exports.makeRePeriodSentenceTextChars = makeRePeriodSentenceTextChars;
class PeriodSentenceTextCharsRule extends generic_parser_1.Rule {
    classSignature = "PeriodSentenceTextCharsRule";
    constructor(name = null) {
        super(name);
    }
    __match__(offset, target, env) {
        const rePeriodSentenceTextChars = env.options.rePeriodSentenceTextChars;
        const m = rePeriodSentenceTextChars?.exec(target.slice(offset));
        if (m) {
            return {
                ok: true,
                nextOffset: offset + m[0].length,
                value: m[0],
                env,
            };
        }
        else {
            return {
                ok: false,
                offset,
                expected: this,
                prevFail: null,
            };
        }
    }
    toString() { return this.name ?? "[PeriodSentenceTextCharsRule]"; }
}
exports.$PERIOD_SENTENCE_FRAGMENT = factory_1.factory
    .withName("PERIOD_SENTENCE_FRAGMENT")
    .choice(c => c
    .or(r => r
    .sequence(c => c
    .and(r => r
    .oneOrMore(r => r
    .choice(c => c
    .or(new PeriodSentenceTextCharsRule())
    .or(() => exports.$charRef)
    .or(new InlineTokenRule())
    .or(r => r.regExp(/^[^\r\n&<>()（）[\]［］{}｛｝「」 　\t。]/))
    .or(() => exports.ANY_PARENTHESES_INLINE)
    .or(() => exports.$MISMATCH_END_PARENTHESIS))), "texts")
    .and(r => r
    .choice(c => c
    .or(r => r.seqEqual("。"))
    .or(r => r.nextIs(() => lexical_1.$__))
    .or(r => r.nextIs(() => lexical_1.$_EOL))), "tail")
    .action(({ texts, tail, offset }) => {
    const target = [...texts, ...(tail ? [tail] : [])];
    const value = [];
    const errors = [];
    let lastOffset = offset();
    for (const t of target) {
        const lastEL = value[value.length - 1];
        if (typeof t === "string") {
            if (lastEL instanceof controls_1.__Text) {
                lastEL.children.splice(0, 1, lastEL.children[0] + t);
                if (lastEL.range)
                    lastEL.range[1] += t.length;
            }
            else {
                value.push(new controls_1.__Text(t, [lastOffset, lastOffset += t.length]));
                lastOffset += t.length;
            }
        }
        else if (lastEL instanceof controls_1.__Text && t.value instanceof controls_1.__Text) {
            lastEL.children.splice(0, 1, lastEL.children[0] + t.value.children[0]);
            if (lastEL.range)
                lastEL.range[1] += t.value.children[0].length;
            errors.push(...t.errors);
        }
        else {
            lastOffset = t.value.range?.[1] ?? lastOffset;
            value.push(t.value);
            errors.push(...t.errors);
        }
    }
    return { value, errors };
})))
    .or(r => r
    .action(r => r
    .sequence(c => c
    .and(r => r.seqEqual("。"), "plain")), (({ plain, range }) => {
    return { value: [new controls_1.__Text(plain, range())], errors: [] };
}))));
exports.$OUTSIDE_PARENTHESES_INLINE_EXCLUDE_TRAILING_SPACES_WITHOUT_TOPLEVEL_INLINE_TOKEN = factory_1.factory
    .withName("OUTSIDE_PARENTHESES_INLINE_EXCLUDE_TRAILING_SPACES_WITHOUT_TOPLEVEL_INLINE_TOKEN")
    .sequence(s => s
    .and(r => r
    .oneOrMore(r => r
    .choice(c => c
    .orSequence(s => s
    .and(r => r
    .regExp(/^(?:(?![ 　\t]*\r?\n)[^\r\n&<>()（）[\]［］{}｛｝「」])+/), "plain")
    .action(({ plain, range }) => {
    return {
        value: new controls_1.__Text(plain, range()),
        errors: [],
    };
})))), "target")
    .action(({ target }) => {
    return {
        value: target.map(t => t.value),
        errors: target.map(t => t.errors).flat(),
    };
}));
const makeReOutsideParenthesesTextChars = (stopChars) => new RegExp(`^(?:(?![ァ-ヿ${stopChars}]|[ 　\t]*\r?\n)[^\r\n&<>()（）[\\]［］{}｛｝「」])+`);
exports.makeReOutsideParenthesesTextChars = makeReOutsideParenthesesTextChars;
class OutsideParenthesesTextCharsRule extends generic_parser_1.Rule {
    classSignature = "OutsideParenthesesTextCharsRule";
    constructor(name = null) {
        super(name);
    }
    __match__(offset, target, env) {
        const reOutsideParenthesesTextChars = env.options.reOutsideParenthesesTextChars;
        const m = reOutsideParenthesesTextChars?.exec(target.slice(offset));
        if (m) {
            return {
                ok: true,
                nextOffset: offset + m[0].length,
                value: m[0],
                env,
            };
        }
        else {
            return {
                ok: false,
                offset,
                expected: this,
                prevFail: null,
            };
        }
    }
    toString() { return this.name ?? "[OutsideParenthesesTextCharsRule]"; }
}
exports.$OUTSIDE_PARENTHESES_INLINE_EXCLUDE_TRAILING_SPACES = factory_1.factory
    .withName("OUTSIDE_PARENTHESES_INLINE_EXCLUDE_TRAILING_SPACES")
    .sequence(s => s
    .and(r => r
    .oneOrMore(r => r
    .choice(c => c
    .or(new OutsideParenthesesTextCharsRule())
    .or(() => exports.$charRef)
    .or(new InlineTokenRule())
    .or(r => r.regExp(/^(?![ 　\t]*\r?\n)[^\r\n&<>()（）[\]［］{}｛｝「」]/)))), "target")
    .action(({ target, offset }) => {
    const value = [];
    const errors = [];
    let lastOffset = offset();
    for (const t of target) {
        const lastEL = value[value.length - 1];
        if (typeof t === "string") {
            const lastEL = value[value.length - 1];
            if (lastEL instanceof controls_1.__Text) {
                lastEL.children.splice(0, 1, lastEL.children[0] + t);
                if (lastEL.range)
                    lastEL.range[1] += t.length;
            }
            else {
                value.push(new controls_1.__Text(t, [lastOffset, lastOffset += t.length]));
                lastOffset += t.length;
            }
        }
        else if (lastEL instanceof controls_1.__Text && t.value instanceof controls_1.__Text) {
            lastEL.children.splice(0, 1, lastEL.children[0] + t.value.children[0]);
            if (lastEL.range)
                lastEL.range[1] += t.value.children[0].length;
            errors.push(...t.errors);
        }
        else {
            lastOffset = t.value.range?.[1] ?? lastOffset;
            value.push(t.value);
            errors.push(...t.errors);
        }
    }
    return { value, errors };
}));
exports.$MISMATCH_START_PARENTHESIS = factory_1.factory
    .withName("MISMATCH_START_PARENTHESIS")
    .sequence(c => c
    .and(r => r
    .asSlice(r => r.regExp(/^[<(（[［{｛「]/)), "mismatch")
    .action(({ mismatch, range }) => {
    const error = new error_1.ErrorMessage("$MISMATCH_START_PARENTHESIS: この括弧に対応する閉じ括弧がありません。", range());
    return {
        value: new controls_1.__MismatchStartParenthesis(mismatch, range()),
        errors: [error],
    };
}));
exports.$MISMATCH_END_PARENTHESIS = factory_1.factory
    .withName("MISMATCH_END_PARENTHESIS")
    .sequence(c => c
    .and(r => r
    .asSlice(r => r.regExp(/^[>)）\]］}｝」]/)), "mismatch")
    .action(({ mismatch, range }) => {
    const error = new error_1.ErrorMessage("$MISMATCH_END_PARENTHESIS: この括弧に対応する開き括弧がありません。", range());
    return {
        value: new controls_1.__MismatchEndParenthesis(mismatch, range()),
        errors: [error],
    };
}));
exports.ANY_PARENTHESES_INLINE = factory_1.factory
    .withName("ANY_PARENTHESES_INLINE")
    .choice(c => c
    .or(() => exports.$ROUND_PARENTHESES_INLINE)
    .or(() => exports.$SQUARE_BRACKETS_INLINE)
    .or(() => exports.$CURLY_BRACKETS_INLINE)
    .or(() => exports.$SQUARE_PARENTHESES_INLINE)
    .orSequence(s => s
    .and(() => _xml_1.default, "elWithError")
    .action(({ elWithError, range }) => {
    const el = elWithError.value;
    if (std.isLine(el) || std.isQuoteStruct(el) || std.isArithFormula(el) || std.isRuby(el) || std.isSup(el) || (0, std_1.isSub)(el) || std.isControl(el)) {
        return {
            value: el,
            errors: elWithError.errors,
        };
    }
    else if (std.isFig(el)) {
        // Not a child of Sentence in stdLaw.xsd
        return {
            value: new el_1.EL("__CapturedXML", {}, [el], range()),
            errors: elWithError.errors,
        };
    }
    else {
        return {
            value: new el_1.EL("__UnexpectedXML", {}, [el], range()),
            errors: [
                ...elWithError.errors,
                new error_1.ErrorMessage(`$PARENTHESES_INLINE_INNER: タグ <${el.tag}> はこの場所では使用できません。`, range()),
            ],
        };
    }
}))
    .or(() => exports.$MISMATCH_START_PARENTHESIS));
const makeReParenthesesInlineTextChars = (stopChars) => new RegExp(`^(?:(?![ァ-ヿ${stopChars}])[^\r\n&<>()（）[\\]［］{}｛｝「」])+`);
exports.makeReParenthesesInlineTextChars = makeReParenthesesInlineTextChars;
class ParenthesesInlineTextCharsRule extends generic_parser_1.Rule {
    classSignature = "ParenthesesInlineTextCharsRule";
    constructor(name = null) {
        super(name);
    }
    __match__(offset, target, env) {
        const reParenthesesInlineTextChars = env.options.reParenthesesInlineTextChars;
        const m = reParenthesesInlineTextChars?.exec(target.slice(offset));
        if (m) {
            return {
                ok: true,
                nextOffset: offset + m[0].length,
                value: m[0],
                env,
            };
        }
        else {
            return {
                ok: false,
                offset,
                expected: this,
                prevFail: null,
            };
        }
    }
    toString() { return this.name ?? "[ParenthesesInlineTextCharsRule]"; }
}
class InlineTokenRule extends generic_parser_1.Rule {
    classSignature = "InlineTokenRule";
    constructor(name = null) {
        super(name);
    }
    __match__(offset, target, env) {
        const rule = env.options.inlineTokenRule;
        const result = (rule instanceof generic_parser_1.Rule) ? rule.match(offset, target, env) : null;
        if (result?.ok) {
            return result;
        }
        else {
            return {
                ok: false,
                offset,
                expected: this,
                prevFail: result,
            };
        }
    }
    toString() { return this.name ?? "[InlineTokenRule]"; }
}
const makeParenthesesInline = (parenthesisType, startPtn, endPtn) => {
    return factory_1.factory
        .choice(c => c
        .orSequence(r => r
        .andOmit(r => r
        .assert(({ state }) => {
        state.parenthesesDepth++;
        return true;
    }))
        .and(r => r
        .sequence(s => s
        .and(r => r.regExp(startPtn))
        .action(({ text, range }) => ({ text: text(), range: range() }))), "start")
        .and(r => r
        .sequence(s => s
        .and(r => r
        .zeroOrMore(r => r
        .choice(c => c
        .or(new ParenthesesInlineTextCharsRule())
        .or(() => exports.$charRef)
        .or(new InlineTokenRule())
        .or(r => r.regExp(/^[^\r\n&<>()（）[\]［］{}｛｝「」]/))
        .or(() => exports.ANY_PARENTHESES_INLINE)
        .or(r => r
        .sequence(c => c
        .and(r => r
        .nextIsNot(r => r.regExp(endPtn)))
        .and(() => exports.$MISMATCH_END_PARENTHESIS, "target")
        .action(({ target }) => {
        return target;
    }))))), "target")
        .action(({ target, offset, range }) => {
        const value = [];
        const errors = [];
        let lastOffset = offset();
        for (const t of target) {
            const lastEL = value[value.length - 1];
            if (typeof t === "string") {
                if (lastEL instanceof controls_1.__Text) {
                    lastEL.children.splice(0, 1, lastEL.children[0] + t);
                    if (lastEL.range)
                        lastEL.range[1] += t.length;
                }
                else {
                    value.push(new controls_1.__Text(t, [lastOffset, lastOffset += t.length]));
                    lastOffset += t.length;
                }
            }
            else if (lastEL instanceof controls_1.__Text && t.value instanceof controls_1.__Text) {
                lastEL.children.splice(0, 1, lastEL.children[0] + t.value.children[0]);
                if (lastEL.range)
                    lastEL.range[1] += t.value.children[0].length;
                errors.push(...t.errors);
            }
            else {
                lastOffset = t.value.range?.[1] ?? lastOffset;
                value.push(t.value);
                errors.push(...t.errors);
            }
        }
        return { value, errors, range: range() };
    })), "content")
        .and(r => r
        .sequence(s => s
        .and(r => r.regExp(endPtn))
        .action(({ text, range }) => ({ text: text(), range: range() }))), "end")
        .andOmit(r => r
        .assert(({ state }) => {
        state.parenthesesDepth--;
        return true;
    }))
        .action(({ start, content, end, state }) => {
        return {
            value: new controls_1.__Parentheses({
                type: parenthesisType,
                depth: state.parenthesesDepth + 1,
                start: start.text,
                end: end.text,
                content: content.value,
                range: {
                    start: start.range,
                    end: end.range,
                    content: content.range,
                },
            }),
            errors: content.errors,
        };
    }))
        .or(r => r
        .sequence(c => c
        .and(r => r
        .assert(({ state }) => {
        state.parenthesesDepth--;
        return false;
    })))));
};
exports.makeParenthesesInline = makeParenthesesInline;
exports.$ROUND_PARENTHESES_INLINE = (0, exports.makeParenthesesInline)("round", /^[(（]/, /^[)）]/);
exports.$ROUND_PARENTHESES_INLINE.name = "ROUND_PARENTHESES_INLINE";
exports.$SQUARE_BRACKETS_INLINE = (0, exports.makeParenthesesInline)("squareb", /^[[［]/, /^[\]］]/);
exports.$SQUARE_BRACKETS_INLINE.name = "SQUARE_BRACKETS_INLINE";
exports.$CURLY_BRACKETS_INLINE = (0, exports.makeParenthesesInline)("curly", /^[{｛]/, /^[}｝]/);
exports.$CURLY_BRACKETS_INLINE.name = "CURLY_BRACKETS_INLINE";
exports.$SQUARE_PARENTHESES_INLINE = factory_1.factory
    .withName("SQUARE_PARENTHESES_INLINE")
    .choice(c => c
    .orSequence(c => c
    .andOmit(r => r
    .assert(({ state }) => {
    state.parenthesesDepth++;
    return true;
}))
    .and(r => r
    .sequence(s => s
    .and(r => r.regExp(/^[「]/))
    .action(({ text, range }) => ({ text: text(), range: range() }))), "start")
    .and(r => r
    .sequence(s => s
    .and(r => r
    .zeroOrMore(r => r
    .choice(c => c
    .or(() => _xml_1.default)
    .or(r => r
    .sequence(c => c
    .and(r => r
    .choice(c => c
    .orSequence(s => s
    .and(r => r
    .asSlice(r => r
    .oneOrMore(r => r.regExp(/^[^\r\n<>「」]/))), "text")
    .action(({ text, range }) => {
    return {
        value: new controls_1.__Text(text, range()),
        errors: [],
    };
}))
    .or(() => exports.$SQUARE_PARENTHESES_INLINE))))))), "value")
    .action(({ value, range }) => {
    return {
        value: value.map(v => v.value),
        errors: value.map(v => v.errors).flat(),
        range: range(),
    };
})), "content")
    .and(r => r
    .sequence(s => s
    .and(r => r.regExp(/^[」]/))
    .action(({ text, range }) => ({ text: text(), range: range() }))), "end")
    .andOmit(r => r
    .assert(({ state }) => {
    state.parenthesesDepth--;
    return true;
}))
    .action(({ start, content, end, state }) => {
    return {
        value: new controls_1.__Parentheses({
            type: "square",
            depth: state.parenthesesDepth + 1,
            start: start.text,
            end: end.text,
            content: content.value,
            range: {
                start: start.range,
                end: end.range,
                content: content.range,
            },
        }),
        errors: content.errors,
    };
}))
    .or(r => r
    .sequence(c => c
    .and(r => r
    .assert(({ state }) => {
    state.parenthesesDepth--;
    return false;
})))));
//# sourceMappingURL=$sentenceChildren.js.map